import type { VendorFactor } from 'modules/supplier/factors/types';
import type { Unit } from 'types';

// factor.py:factor_is_applicable, except for vendor part

export function factorIsApplicable(rowUnit: Unit | null, factor: VendorFactor): boolean {
  switch (factor.kind) {
    case 'MONTHLY': {
      if (rowUnit === 'DAY' || rowUnit === 'WEEK' || rowUnit === 'MONTH') {
        return true;
      }
      return false;
    }
    case 'WEEKLY': {
      if (rowUnit === 'DAY' || rowUnit === 'WEEK' || rowUnit === 'MONTH') {
        return true;
      }
      return false;
    }
  }

  return true;
}
